// ABOUTME: Picks the color for the requested delivery time in RMC order intake views.
// ABOUTME: Without slot management the time is never confirmed upfront, so it is shown as pending.
export const getRequestedTimeColor = (
  palette: {success: {main: string}; warning: {main: string}},
  slotManagementEnabled: boolean,
  requiresDispatchApproval?: boolean
): string =>
  slotManagementEnabled && !requiresDispatchApproval ? palette.success.main : palette.warning.main
